(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-hair-length';
  var sectionState = new Map();

  function initSection(section) {
    if (!section || sectionState.has(section)) return;

    var wrapper = section.querySelector('.oddit-section-hair-length__cards-wrapper');
    var cards = section.querySelectorAll('.oddit-section-hair-length__card');
    var dots = section.querySelectorAll('.oddit-section-hair-length__dot');
    var prevBtn = section.querySelector('.oddit-section-hair-length__nav-btn--prev');
    var nextBtn = section.querySelector('.oddit-section-hair-length__nav-btn--next');

    if (!wrapper || cards.length === 0) return;

    var state = {
      currentIndex: 0,
      cards: cards,
      dots: dots,
      wrapper: wrapper,
      prevBtn: prevBtn,
      nextBtn: nextBtn,
      ro: null,
      observer: null,
    };

    function setActive(index) {
      var clamped = Math.max(0, Math.min(index, cards.length - 1));
      state.currentIndex = clamped;

      dots.forEach(function (dot, i) {
        var isActive = i === clamped;
        dot.classList.toggle('oddit-section-hair-length__dot--active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      if (prevBtn) prevBtn.disabled = clamped === 0;
      if (nextBtn) nextBtn.disabled = clamped === cards.length - 1;
    }

    function scrollToIndex(index) {
      var clamped = Math.max(0, Math.min(index, cards.length - 1));
      var target = cards[clamped];
      if (!target) return;

      var wrapperRect = wrapper.getBoundingClientRect();
      var targetRect = target.getBoundingClientRect();
      var delta = targetRect.left - wrapperRect.left;
      wrapper.scrollTo({
        left: wrapper.scrollLeft + delta,
        behavior: 'smooth',
      });
    }

    function handleScroll() {
      var wrapperRect = wrapper.getBoundingClientRect();
      var bestIndex = 0;
      var bestDistance = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var rect = cards[i].getBoundingClientRect();
        var distance = Math.abs(rect.left - wrapperRect.left);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = i;
        }
      }
      if (bestIndex !== state.currentIndex) {
        setActive(bestIndex);
      }
    }

    function handleDotClick(e) {
      var dot = e.target.closest('[data-index]');
      if (!dot) return;
      var idx = parseInt(dot.getAttribute('data-index'), 10);
      if (isNaN(idx)) return;
      setActive(idx);
      scrollToIndex(idx);
    }

    function handleNavClick(e) {
      var btn = e.currentTarget;
      var direction = btn.getAttribute('data-direction');
      var nextIdx = direction === 'next' ? state.currentIndex + 1 : state.currentIndex - 1;
      setActive(nextIdx);
      scrollToIndex(nextIdx);
    }

    // Bind events
    dots.forEach(function (dot) {
      dot.addEventListener('click', handleDotClick);
    });

    if (prevBtn) prevBtn.addEventListener('click', handleNavClick);
    if (nextBtn) nextBtn.addEventListener('click', handleNavClick);

    var rafScroll = null;
    wrapper.addEventListener(
      'scroll',
      function () {
        if (rafScroll) cancelAnimationFrame(rafScroll);
        rafScroll = requestAnimationFrame(handleScroll);
      },
      { passive: true }
    );

    state.cleanupRaf = function () {
      if (rafScroll) cancelAnimationFrame(rafScroll);
    };

    setActive(0);
    sectionState.set(section, state);
  }

  function destroySection(section) {
    var state = sectionState.get(section);
    if (!state) return;
    if (state.cleanupRaf) state.cleanupRaf();
    sectionState.delete(section);
  }

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll(SECTION_SELECTOR);
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();